import type { EditorAboveOptions, SlateEditor } from '@udecode/plate';

import { BaseTablePlugin } from '../BaseTablePlugin';
import type { TTableElement } from '../types';

export const setTableAlign = (
    editor: SlateEditor,
    { align }: { align: TTableElement['align'] },
    options: EditorAboveOptions = {}
) => {
    const table = editor.api.node<TTableElement>({
        match: { type: BaseTablePlugin.key },
        ...options,
    });

    if (!table) return;

    const [, tablePath] = table;

    editor.tf.setNodes<TTableElement>({ align }, { at: tablePath });
};
